import React, { useState } from 'react';
import Modal from '../Components/Modal/Modal';

function ModalPage() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <button onClick={openModal} className='modal_open'>Open Modal</button>
            {isModalOpen && <Modal onClose={closeModal} />}
        </>
    );
}

export default ModalPage;
